import React from "react"
import { Skeleton } from "@material-ui/lab"
import {
	Grid,
	Card,
	Avatar
} from "@material-ui/core"

import useStyles from "@/pages/Admin/MeetingAnalyzer/Detail/styles"

const MeetingAnalyzerDetailSkeleton = () => {
	const classes = useStyles()

	return (
		<Grid container direction="column" spacing={3}>
			<Grid item xs={12}>
				<Skeleton variant="rect" width={300} height={20} />
			</Grid>
			<Grid item xs={12}>
				<Grid container direction="column" spacing={0}>
					<Grid item xs={12}>
						<Grid container justifyContent="space-between" alignItems="flex-start">
							<Grid item xs={6}>
								<Skeleton variant="text" width="80%" height={40} />
							</Grid>
							<Grid item>
								<Skeleton variant="circle" width={40} height={40} />
							</Grid>
						</Grid>
					</Grid>
					<Grid item xs={12}>
						<Card className={classes.card}>
							<Grid container justifyContent="space-between" alignItems="center" spacing={3}>
								<Grid item>
									<Grid container alignItems="center" spacing={2}>
										<Grid item>
											<Avatar className={classes.closerAvatar}>
												<Skeleton variant="circle" width={40} height={40} />
											</Avatar>
										</Grid>
										<Grid item>
											<Grid container direction="column">
												<Grid item>
													<Skeleton variant="text" width={50} height={14} />
												</Grid>
												<Grid item>
													<Skeleton variant="text" width={120} height={20} />
												</Grid>
											</Grid>
										</Grid>
									</Grid>
								</Grid>
								<Grid item>
									<Grid container direction="column">
										<Grid item>
											<Skeleton variant="text" width={40} height={14} />
										</Grid>
										<Grid item>
											<Skeleton variant="text" width={200} height={20} />
										</Grid>
									</Grid>
								</Grid>
								<Grid item>
									<Grid container direction="column" spacing={1}>
										<Grid item>
											<Skeleton variant="text" width={180} height={20} />
										</Grid>
										<Grid item>
											<Skeleton variant="text" width={140} height={14} />
										</Grid>
										<Grid item>
											<Skeleton variant="text" width={100} height={20} />
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</Card>
					</Grid>
				</Grid>
			</Grid>
			<Grid item xs={12}>
				<Card className={classes.card}>
					<Grid container spacing={4} alignItems="center">
						<Grid item xs={3}>
							<Grid container direction="column" spacing={2} className={classes.scoreColumn}>
								<Grid item>
									<Skeleton variant="text" width={100} height={14} />
								</Grid>
								<Grid item>
									<Skeleton variant="text" width={80} height={60} />
								</Grid>
								<Grid item>
									<Skeleton variant="rect" width={120} height={24} style={{ borderRadius: 999 }} />
								</Grid>
							</Grid>
						</Grid>
						<Grid item xs={9}>
							<Grid container direction="column" spacing={2}>
								<Grid item>
									<Skeleton variant="text" width={140} height={20} />
								</Grid>
								<Grid item>
									<Grid container spacing={2}>
										{[0, 1, 2].map(index => (
											<Grid item xs={4} key={index}>
												<Grid container direction="column" spacing={1} className={classes.topicSubCard}>
													<Grid item>
														<Skeleton variant="text" width="80%" height={18} />
													</Grid>
													<Grid item>
														<Skeleton variant="text" width={40} height={28} />
													</Grid>
													<Grid item>
														<Skeleton variant="rect" width="100%" height={6} style={{ borderRadius: 4 }} />
													</Grid>
													<Grid item>
														<Skeleton variant="text" width={60} height={14} />
													</Grid>
												</Grid>
											</Grid>
										))}
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Card>
			</Grid>
			<Grid item xs={12}>
				<Card className={classes.card}>
					<Grid container direction="column" spacing={2}>
						<Grid item>
							<Grid container spacing={3}>
								<Grid item>
									<Skeleton variant="rect" width={40} height={40} style={{ borderRadius: 10 }} />
								</Grid>
								<Grid item xs>
									<Grid container direction="column" spacing={1}>
										<Grid item>
											<Skeleton variant="text" width={140} height={14} />
										</Grid>
										<Grid item>
											<Skeleton variant="text" width={100} height={28} />
										</Grid>
										<Grid item>
											<Skeleton variant="text" width="90%" height={14} />
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
						<Grid item xs={12}>
							<Grid container className={classes.profilePillsRow}>
								{[0, 1, 2, 3].map(index => (
									<Grid item key={index}>
										<Skeleton variant="rect" width={100} height={28} style={{ borderRadius: 999 }} />
									</Grid>
								))}
							</Grid>
						</Grid>
					</Grid>
				</Card>
			</Grid>
			<Grid item xs={12}>
				<Card className={classes.card}>
					<Grid container direction="column" spacing={2}>
						<Grid item>
							<Skeleton variant="text" width={160} height={20} />
						</Grid>
						<Grid item>
							<Skeleton variant="rect" width="100%" height={28} style={{ borderRadius: 8 }} />
						</Grid>
						<Grid item>
							<Grid container spacing={4}>
								<Grid item>
									<Skeleton variant="text" width={80} height={20} />
								</Grid>
								<Grid item>
									<Skeleton variant="text" width={80} height={20} />
								</Grid>
							</Grid>
						</Grid>
						<Grid item>
							<Skeleton variant="rect" width="100%" height={60} style={{ borderRadius: 8 }} />
						</Grid>
					</Grid>
				</Card>
			</Grid>
			<Grid item xs={12}>
				<Grid container spacing={3}>
					<Grid item xs={6}>
						<Card className={classes.card}>
							<Grid container direction="column" spacing={2}>
								<Grid item>
									<Skeleton variant="text" width={140} height={20} />
								</Grid>
								<Grid item>
									<Skeleton variant="text" width="90%" height={14} />
								</Grid>
								<Grid item>
									<Skeleton variant="text" width="80%" height={18} />
								</Grid>
								<Grid item>
									<Skeleton variant="rect" width="100%" height={60} style={{ borderRadius: 8 }} />
								</Grid>
							</Grid>
						</Card>
					</Grid>
					<Grid item xs={6}>
						<Card className={classes.card}>
							<Grid container direction="column" spacing={2}>
								<Grid item>
									<Skeleton variant="text" width={180} height={20} />
								</Grid>
								<Grid item>
									<Skeleton variant="text" width="90%" height={14} />
								</Grid>
								<Grid item>
									<Grid container alignItems="center" justifyContent="center">
										<Skeleton variant="circle" width={120} height={120} />
									</Grid>
								</Grid>
							</Grid>
						</Card>
					</Grid>
				</Grid>
			</Grid>
			<Grid item xs={12}>
				<Card className={classes.card}>
					<Grid container direction="column" spacing={2}>
						<Grid item>
							<Skeleton variant="text" width={200} height={20} />
						</Grid>
						<Grid item>
							<Skeleton variant="text" width="80%" height={14} />
						</Grid>
						<Grid item>
							<Grid container direction="column" spacing={1}>
								{[0, 1].map(index => (
									<Grid item key={index}>
										<Skeleton variant="rect" width="100%" height={48} style={{ borderRadius: 8 }} />
									</Grid>
								))}
							</Grid>
						</Grid>
					</Grid>
				</Card>
			</Grid>
			<Grid item xs={12}>
				<Grid container spacing={3}>
					<Grid item xs={6}>
						<Card className={classes.achievementCard}>
							<Grid container direction="column" spacing={2}>
								<Grid item>
									<Grid container alignItems="center" spacing={2}>
										<Grid item>
											<Skeleton variant="rect" width={32} height={32} style={{ borderRadius: 8 }} />
										</Grid>
										<Grid item>
											<Grid container direction="column">
												<Grid item>
													<Skeleton variant="text" width={120} height={14} />
												</Grid>
												<Grid item>
													<Skeleton variant="rect" width={80} height={24} style={{ borderRadius: 999 }} />
												</Grid>
											</Grid>
										</Grid>
									</Grid>
								</Grid>
								<Grid item>
									<Skeleton variant="text" width="90%" height={18} />
								</Grid>
								<Grid item>
									<Skeleton variant="text" width="80%" height={14} />
								</Grid>
							</Grid>
						</Card>
					</Grid>
					<Grid item xs={6}>
						<Card className={classes.errorCard}>
							<Grid container direction="column" spacing={2}>
								<Grid item>
									<Grid container alignItems="center" spacing={2}>
										<Grid item>
											<Skeleton variant="rect" width={32} height={32} style={{ borderRadius: 8 }} />
										</Grid>
										<Grid item>
											<Grid container direction="column">
												<Grid item>
													<Skeleton variant="text" width={100} height={14} />
												</Grid>
												<Grid item>
													<Skeleton variant="rect" width={80} height={24} style={{ borderRadius: 999 }} />
												</Grid>
											</Grid>
										</Grid>
									</Grid>
								</Grid>
								<Grid item>
									<Skeleton variant="text" width="90%" height={18} />
								</Grid>
								<Grid item>
									<Skeleton variant="text" width="80%" height={14} />
								</Grid>
							</Grid>
						</Card>
					</Grid>
				</Grid>
			</Grid>
			<Grid item xs={12}>
				<Card className={classes.card}>
					<Grid container direction="column" spacing={2}>
						<Grid item>
							<Skeleton variant="text" width={200} height={20} />
						</Grid>
						<Grid item>
							<Skeleton variant="text" width="80%" height={14} />
						</Grid>
						<Grid item>
							<Grid container direction="column" spacing={2}>
								{[0, 1, 2].map(index => (
									<Grid item key={index}>
										<Skeleton variant="rect" width="100%" height={40} style={{ borderRadius: 8 }} />
									</Grid>
								))}
							</Grid>
						</Grid>
					</Grid>
				</Card>
			</Grid>
		</Grid>
	)
}

export default MeetingAnalyzerDetailSkeleton
